import { withChartLayout } from 'components/common';
import RespiratoryAssessment from 'components/features/chart/system-assessment/respiratory-assessment/RespiratoryAssessment';

const RespiratoryAssessmentPage = withChartLayout('Respiratory Assessment')(RespiratoryAssessment);
export default RespiratoryAssessmentPage;
